export default {
  timeoutInSeconds: 60,
};
